import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';

// Main Links Page Component
function MainPage() {
  const mainLinks = [
    {
      name: 'youtube',
      url: 'https://www.youtube.com/@chances_are_low',
      icon: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      )
    },
    {
      name: 'tiktok',
      url: 'https://www.tiktok.com/@chances_are_low',
      icon: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43V7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.43z"/>
        </svg>
      )
    },
    {
      name: 'instagram',
      url: 'https://www.instagram.com/chances_are_low',
      icon: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor"/>
        </svg>
      )
    },
    {
      name: 'patreon',
      url: 'http://patreon.com/c/chances_are_low',
      icon: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M14.82 2.41c3.96 0 7.18 3.24 7.18 7.21 0 3.96-3.22 7.18-7.18 7.18-3.97 0-7.21-3.22-7.21-7.18 0-3.97 3.24-7.21 7.21-7.21zM2 21.6h3.5V2.41H2V21.6z"/>
        </svg>
      )
    }
  ];

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Title */}
        <h1 className="text-white text-4xl font-light text-center mb-12">
          gandi's links
        </h1>
        
        {/* All Links */}
        <div>
          {/* Main Links */}
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              className="flex items-center justify-center w-full p-4 bg-transparent border border-gray-700 rounded-lg text-white hover:bg-gray-900 hover:border-gray-600 transition-colors duration-200 mb-4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="flex items-center space-x-3">
                {link.icon}
                <span className="text-lg font-light">{link.name}</span>
              </div>
            </a>
          ))}

          {/* Donate Link */}
          <Link
            to="/donate"
            className="flex items-center justify-center w-full p-4 bg-transparent border border-gray-700 rounded-lg text-white hover:bg-gray-900 hover:border-gray-600 transition-colors duration-200"
          >
            <div className="flex items-center space-x-3">
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              <span className="text-lg font-light">donations</span>
            </div>
          </Link>
        </div>
        
        {/* Footer */}
        <p className="text-gray-500 text-sm text-center mt-16">
          © 2025 gandi's links
        </p>
      </div>
    </div>
  );
}

// Donate Page Component
function DonatePage() {
  const donateOptions = [
    {
      name: 'paypal',
      url: 'https://www.paypal.me/armengandilian',
      icon: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.26-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81.675.771 1.066 1.638 1.134 2.67v.001c0 .014 0 .027.002.04.015.2.018.4.01.597-.014.32-.043.638-.085.952-.042.314-.098.625-.168.933a3.685 3.685 0 0 1-.22.72z"/>
        </svg>
      )
    },
    {
      name: 'buy me a coffee',
      url: 'https://buymeacoffee.com/chances_are_low',
      icon: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
          {/* Coffee cup */}
          <path d="M2 21h17l-2-9H4l-2 9zM20 3H4v5c0 2 2 4 4 4h6c2 0 4-2 4-4V3z" fill="currentColor" opacity="0.8"/>
          <path d="M20 7h2c1.1 0 2 .9 2 2s-.9 2-2 2h-2" stroke="currentColor" strokeWidth="1" fill="none"/>
          {/* Steam */}
          <path d="M7 1v2M10 1v2M13 1v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )
    }
  ];

  // Crypto donations gets its own route
  const cryptoOption = {
    name: 'crypto donations',
    route: '/crypto',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="12" r="12" fill="currentColor"/>
        <path d="M17.12 10.78c.14-1.08-.66-1.66-1.79-2.04l.37-1.46-1.08-.25-.36 1.42c-.28-.07-.57-.14-.86-.2l.36-1.43-1.08-.25-.37 1.46c-.23-.05-.46-.1-.68-.16v-.02l-1.49-.34-.29 1.1s.8.18.78.19c.44.11.52.4.5.63l-.5 1.99c.03.01.07.02.11.04-.04-.01-.08-.02-.11-.04l-.7 2.8c-.05.13-.19.32-.5.25.01.02-.78-.19-.78-.19l-.53 1.18 1.4.32c.26.07.52.14.77.2l-.37 1.48 1.08.25.37-1.46c.29.08.57.15.85.22l-.37 1.45 1.08.25.37-1.48c1.53.29 2.68.17 3.16-1.21.39-1.11-.02-1.75-.82-2.17.58-.13 1.02-.52 1.13-1.32zm-2.02 2.83c-.28 1.1-2.14.51-2.75.36l.49-1.95c.61.15 2.54.46 2.26 1.59zm.28-2.85c-.25.99-1.79.49-2.29.37l.44-1.77c.5.12 2.11.35 1.85 1.4z" fill="white"/>
      </svg>
    )
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Title */}
        <h1 className="text-white text-4xl font-light text-center mb-12">
          donate
        </h1>
        
        {/* Back Button */}
        <div className="mb-8">
          <Link
            to="/"
            className="flex items-center text-gray-400 hover:text-white transition-colors duration-200"
          >
            <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
            <span>back to links</span>
          </Link>
        </div>
        
        {/* Donate Options */}
        <div className="space-y-4">
          {donateOptions.map((option, index) => (
            <a
              key={index}
              href={option.url}
              className="flex items-center justify-center w-full p-4 bg-transparent border border-gray-700 rounded-lg text-white hover:bg-gray-900 hover:border-gray-600 transition-colors duration-200"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="flex items-center space-x-3">
                {option.icon}
                <span className="text-lg font-light">{option.name}</span>
              </div>
            </a>
          ))}
          
          {/* Crypto donations as internal link */}
          <Link
            to="/crypto"
            className="flex items-center justify-center w-full p-4 bg-transparent border border-gray-700 rounded-lg text-white hover:bg-gray-900 hover:border-gray-600 transition-colors duration-200"
          >
            <div className="flex items-center space-x-3">
              {cryptoOption.icon}
              <span className="text-lg font-light">{cryptoOption.name}</span>
            </div>
          </Link>
        </div>
        
        {/* Thank you message */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 text-sm">
            thank you for your support! ♥
          </p>
        </div>
        
        {/* Footer */}
        <p className="text-gray-500 text-sm text-center mt-16">
          © 2025 gandi's links
        </p>
      </div>
    </div>
  );
}

// Crypto Donations Page Component
function CryptoPage() {
  const cryptoWallets = [
    {
      name: 'Bitcoin (BTC)',
      address: 'bc1qj57qncyxvzhnw99v3nrszehy8tj5e07s7s3yf2',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="12" fill="#f7931a"/>
          <path d="M17.12 10.78c.14-1.08-.66-1.66-1.79-2.04l.37-1.46-1.08-.25-.36 1.42c-.28-.07-.57-.14-.86-.2l.36-1.43-1.08-.25-.37 1.46c-.23-.05-.46-.1-.68-.16v-.02l-1.49-.34-.29 1.1s.8.18.78.19c.44.11.52.4.5.63l-.5 1.99c.03.01.07.02.11.04-.04-.01-.08-.02-.11-.04l-.7 2.8c-.05.13-.19.32-.5.25.01.02-.78-.19-.78-.19l-.53 1.18 1.4.32c.26.07.52.14.77.2l-.37 1.48 1.08.25.37-1.46c.29.08.57.15.85.22l-.37 1.45 1.08.25.37-1.48c1.53.29 2.68.17 3.16-1.21.39-1.11-.02-1.75-.82-2.17.58-.13 1.02-.52 1.13-1.32zm-2.02 2.83c-.28 1.1-2.14.51-2.75.36l.49-1.95c.61.15 2.54.46 2.26 1.59zm.28-2.85c-.25.99-1.79.49-2.29.37l.44-1.77c.5.12 2.11.35 1.85 1.4z" fill="white"/>
        </svg>
      )
    },
    {
      name: 'Ethereum (ETH)',
      address: '0xdc99F172F1901D6C465fe9d160c15738218271B1',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="12" fill="#627eea"/>
          <path d="M11.944 17.97L6.566 14.783l5.378 2.28 5.378-2.28L11.944 17.97zM12 16.216l-5.25-2.226L12 3.47l5.25 10.52L12 16.216z" fill="white"/>
        </svg>
      )
    },
    {
      name: 'USDT (TRC20)',
      address: 'TMrbREm17TQts4mkSGcXjgmhB2uoGu42TA',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="12" fill="#26a17b"/>
          <path d="M12.87 8.64V7.12h2.87V5.17h-7.48v1.95h2.87v1.52c-2.22.13-3.89.77-3.89 1.5s1.67 1.37 3.89 1.5v4.08c0 .29.24.53.53.53h.34c.29 0 .53-.24.53-.53v-4.08c2.22-.13 3.89-.77 3.89-1.5s-1.67-1.37-3.89-1.5zm0 2.45v-.9c1.71.09 2.95.45 2.95.9s-1.24.81-2.95.9z" fill="white"/>
        </svg>
      )
    },
    {
      name: 'Solana (SOL)',
      address: 'BxZ4nS9yxDC6hBoY34aMFhdZhy6hVb7zuiyUqmdHoZAC',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="12" fill="#9945FF"/>
          <path d="M8.5 17.5l11-11M8.5 6.5l11 11M3.5 12l17 0" stroke="white" strokeWidth="2" strokeLinecap="round" fill="none"/>
        </svg>
      )
    }
  ];

  const copyToClipboard = async (address, coinName) => {
    try {
      await navigator.clipboard.writeText(address);
      const button = document.querySelector(`[data-address="${address}"]`);
      const originalText = button.textContent;
      button.textContent = 'copied!';
      button.style.background = '#10b981';
      
      setTimeout(() => {
        button.textContent = originalText;
        button.style.background = '';
      }, 2000);
      
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = address;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      const button = document.querySelector(`[data-address="${address}"]`);
      const originalText = button.textContent;
      button.textContent = 'copied!';
      button.style.background = '#10b981';
      
      setTimeout(() => {
        button.textContent = originalText;
        button.style.background = '';
      }, 2000);
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-lg">
        {/* Title */}
        <h1 className="text-white text-4xl font-light text-center mb-12">
          crypto donations
        </h1>
        
        {/* Back Button */}
        <div className="mb-8">
          <Link
            to="/donate"
            className="flex items-center text-gray-400 hover:text-white transition-colors duration-200"
          >
            <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
            <span>back to donate</span>
          </Link>
        </div>
        
        {/* Crypto Wallets */}
        <div className="space-y-6">
          {cryptoWallets.map((wallet, index) => (
            <div key={index} className="bg-transparent border border-gray-700 rounded-lg p-6">
              {/* Coin Header */}
              <div className="flex items-center mb-4">
                {wallet.icon}
                <h3 className="text-white text-xl font-medium ml-3">{wallet.name}</h3>
              </div>
              
              {/* Address */}
              <div className="bg-gray-900 rounded-lg p-4 mb-4">
                <p className="text-gray-300 text-sm font-mono break-all leading-relaxed">
                  {wallet.address}
                </p>
              </div>
              
              {/* Copy Button */}
              <button
                onClick={() => copyToClipboard(wallet.address, wallet.name)}
                data-address={wallet.address}
                className="w-full bg-white text-black py-3 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors duration-200"
              >
                copy address
              </button>
            </div>
          ))}
        </div>
        
        {/* Thank you message */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 text-sm">
            thank you for your crypto support! 🚀
          </p>
        </div>
        
        {/* Footer */}
        <p className="text-gray-500 text-sm text-center mt-16">
          © 2025 gandi's links
        </p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/crypto" element={<CryptoPage />} />
      </Routes>
    </Router>
  );
}

export default App;
